module.exports = __webpack_public_path__ + "img/img.b9365d22.png";